module.exports = __webpack_public_path__ + "img/cleaningagents_icon.6c2030aa.svg";